import React, { useEffect, useState } from "react";
import "../Downloadfiles/Downloadfile.css";
import {
  FaDownload,
  FaLock,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileArchive,
  FaFileAlt,
} from "react-icons/fa";
import axios from "../../utils/axiosConfig";

const API = "/api/downloads";

/* FILE ICON */
const getFileIcon = (type) => {
  if (!type) return <FaFileAlt className="icon default" />;

  if (type.includes("pdf")) return <FaFilePdf className="icon pdf" />;
  if (type.includes("word")) return <FaFileWord className="icon doc" />;
  if (type.includes("excel")) return <FaFileExcel className="icon xls" />;
  if (type.includes("zip")) return <FaFileArchive className="icon zip" />;

  return <FaFileAlt className="icon default" />;
};

/* DATE FORMAT */
// const formatDate = (dateString) => {
//   if (!dateString) return "";
//   const d = new Date(dateString);
//   return `${String(d.getDate()).padStart(2, "0")}-${String(
//     d.getMonth() + 1
//   ).padStart(2, "0")}-${d.getFullYear()}`;
// };

const Downloadfile = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(API);

      const formatted = res.data.map((item) => ({
        id: item.id,
        filename: item.filename,
        description: item.originalname,
        descriptiontype: item.description,
        type: item.filetype || "",
        size: item.filesize || "",
        category: item.category || "General",
        date: item.created_at,
        active: item.active,
      }));

      setData(formatted);
    };

    fetchData();
  }, []);

  const categories = ["All", ...new Set(data.map((i) => i.category))];

  const filteredData = data.filter((item) => {
    return (
      (category === "All" || item.category === category) &&
      item.description.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <section className="download-section">
      <div className="container download-container">

        <div className="download-header">
          <h2>NPCA DOWNLOAD CENTER</h2>
          <p>All important files for Download</p>
        </div>

        <div className="download-controls">
          <input
            type="text"
            placeholder="Search files..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            {categories.map((cat, i) => (
              <option key={i}>{cat}</option>
            ))}
          </select>
        </div>

        <div className="download-list">
          {filteredData.map((item) => (
            <div
              key={item.id}
              className={`download-row ${item.active ? "" : "inactive"}`}
            >
              <div className="file-icon">{getFileIcon(item.type)}</div>

              <div className="file-info">
                <h4>{item.description}</h4>
                <div className="file-meta">
                  <span>
                    {item.type && item.type.split("/")[1]
                      ? item.type.split("/")[1].toUpperCase()
                      : ""}
                  </span>
                  <span>{item.size}</span>
                  {/* <span>{formatDate(item.date)}</span> */}
                  <span>{item.date}</span>
                </div>
              </div>

              <div className="file-info">
                <h4>{item.descriptiontype}</h4>
              </div>

              <div className="file-action">
                {item.active ? (
                  <a
                    href={`/api/downloads/download/${item.filename.split("/").pop()}`}
                    download={item.description}
                    className="download-btn"
                  >
                    <FaDownload /> Download
                  </a>
                ) : (
                  <button className="download-btn disabled" disabled>
                    <FaLock /> Locked
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Downloadfile;